import { mapGetters } from "vuex";
import confirmationPageMixin from "@/pages/confirmation/mixin";

export default {
  mixins: [confirmationPageMixin],
  computed: {
    ...mapGetters("app", ["isStripeEnabled"]),
  },
  metaInfo() {
    const title = "Opłaty związane z podróżami z Getaway - sprawdź szczegóły";
    const description =
      "Opłaty Getaway - nasza propozycja wyjazdu jest zawsze bezpłatna i niezobowiązująca. Prowizję pobieramy dopiero przy zakupie wyjazdu.";
    return {
      title,
      meta: [
        {
          property: "og:title",
          content: title,
          vmid: "og:title",
        },
        {
          property: "og:description",
          content: description,
          vmid: "og:description",
        },
        {
          name: "description",
          content: description,
          vmid: "description",
        },
      ],
    };
  },
};
